/**
 * e-Dilo integration API
 */
import Cookies from 'js-cookie';
import fetcher from '../api';
import { showError } from './apiService';

export const eDiloService = {
	getCurrentLimit: async (account: string) => {
		const phone = localStorage.getItem('ik:phone');
		const token: string | undefined = Cookies.get('token');
		const res = await fetcher.post(
			{
				url: `LimitCredit/${phone}/${token}`,
				data: {
					Контрагент: account,
				},
			},
			showError,
		);

		return (await res) || [];
	},
	requestCredit: async ({ wallet, email, amount, price, nomenclature, contract }: {
		wallet: string,
		email: string,
		nomenclature: string,
		amount: number,
		price: number,
		contract: string
	}) => {
		const phone = localStorage.getItem('ik:phone');
		const token: string | undefined = Cookies.get('token');
		const res = await fetcher.post(
			{
				url: `GetOnlineCredit/${phone}/${token}`,
				data: {
					'Счет': wallet,
					'Email': email,
					'Договор': contract,
					'Заказ': [
						{
							'Номенклатура': nomenclature,
							'Количество': amount,
							'Цена': price,
						},
					],
					'СрокКредитования': 3,
				},
			},
			showError,
		);

		return (await res) || [];
	},
	changeOrderToCredit: async ({ wallet, invoiceUid, email }: {
		wallet: string,
		invoiceUid: string,
		email: string,
	}) => {
		const phone = localStorage.getItem('ik:phone');
		const token: string | undefined = Cookies.get('token');
		const res = await fetcher.post(
			{
				url: `GhangeOrderToCredit/${phone}/${token}`,
				data: {
					'Счет': wallet,
					'УИДСчетаНаОплату': invoiceUid,
					'Email': email,
					'СрокКредитования': 3,
				},
			},
			showError,
		);

		return (await res) || [];
	},
};